// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import icons from './icons';

function formatIcon(name: string) {
  return name
    .replace(name[0], name[0].toUpperCase())
    .replace(/-(\w)/g, function(all, letter) {
      return letter.toUpperCase();
    });
}

export function patchRoutes(props) {
  Object.entries(props.routes).forEach(([id,route])=>{
    // route['routeComponent'] = props.routeComponents[id]
    const { icon } = route;
    if (icon && typeof icon === 'string') {
      const upperIcon = formatIcon(icon);
      if (icons[upperIcon] || icons[upperIcon + 'Outlined']) {
        route.icon = React.createElement(icons[upperIcon] || icons[upperIcon + 'Outlined']);
      }
    }
  })
}
